import { render, staticRenderFns } from "./check-email.vue?vue&type=template&id=3821924c&scoped=true&"
import script from "./check-email.vue?vue&type=script&lang=js&"
export * from "./check-email.vue?vue&type=script&lang=js&"
import style0 from "./check-email.vue?vue&type=style&index=0&id=3821924c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3821924c",
  null
  
)

export default component.exports